<template>
  <div class="c-product-resume col-12 u-marg-t-ml">
    <!-- <div class="c-product-resume__content-separator"></div> -->
    <div class="c-product-resume__content">
    <p class="t-h2 c-product-capacity-text ordered-props"><span class="n-label n-label--black">4</span> <span>{{ $t('Summary') }}</span></p>

      <p class="t-h2 u-marg-b-sm"></p>

      <dl class="row u-bold">
        <div class="col-12 col-sm-6">
            <div class="c-product-resume__content-line">
              <dt class="t-h3">{{ $t('Phone price') }}</dt>
              <dd class="u-orange2 t-h3 u-marg-l-xxxs">{{ mobilePrice }}</dd>
            </div>

            <div class="c-product-resume__content-line">
              <dt>
                <button
                  id="popover-monthly"
                  class="t-info t-h3 t-button-reinitialize u-black resume-popover"
                  type="button"
                  @click="currentPopeOver = 'popover-monthly'"
                  data-toggle="popover"
                  :data-placement="popOverPlacement"
                  data-container="#devices"
                  data-html="true"
                  :title="$t('Monthly price details')"
                  :data-content="templateBasePopOver('popover-monthly')">
                    {{ $t('Pay monthly') }}
                </button>
              </dt>
              <dd>
                <span class="u-orange2 t-h3 u-marg-l-xxxs">{{ monthlyPrice }}</span>
              </dd>
            </div>
            <div class="c-product-resume__content-line" style="margin-top: 0">
                <dt>
                    <span style="opacity: 0">
                        {{ $t('Pay monthly') }}
                    </span>
                </dt>
                <dd>
                    <span class="c-pricing__muted-text u-weight-normal u-inline-block u-grey-text u-marg-l-ml"
                          style="font-size: 11px; margin-top: 3px"
                          v-if="this.currentProduct.plan.plan_promo_subscription_duration && this.currentProduct.plan.plan_promo_subscription_duration.length > 0 && dateTimeForPlansPromo"
                          v-html= textForDiscountPromo >
                    </span>
                </dd>
                </div>

        </div>
        <div class="col-12 col-sm-6 c-product-resume__content-instalment">
          <div class="c-product-resume__content-line">
            <dt class="t-h3">{{ $t('Activation fees') }}</dt>
            <dd v-if="hasInstalmentFee" class="u-orange2 t-h3 u-marg-l-xxxs">{{ currentProduct.plan.activation_fees }} {{ currentProduct.currency }}</dd>
            <dd v-if="!hasInstalmentFee" class="u-orange2 t-h3 u-marg-l-xxxs">{{ $t('free.male') }}</dd>
          </div>

          <div class="c-product-resume__content-line">
            <dt class="t-h3">
              {{ $t('Shipping fees') }}
              <svg class="u-marg-l-xxxs t-h3 c-delivery-icon t-icon t-icon--sm">
                <use xlink:href="#icon-delivery"></use>
              </svg>
            </dt>

            <dd class="u-orange2 t-h3 u-marg-l-xxxs">{{ $t('free.male') }}</dd>
          </div>

            <div class="u-weight-normal u-grey-text" style="font-size: 11px; margin-top: 3px;">
                <span class="c-line-legend">{{ productInformations.shipping_legend }}</span>
            </div>
        </div>
      </dl>
    </div>

    <!-- <div class="c-product-resume__content d-flex align-items-center justify-content-sm-start justify-content-between mt-sm-1 mt-3 mb-1">
      <div class="d-flex align-items-center">
        <div class="icon__charger mr-2"></div>
        <div class="charger-info u-grey-text t-h2--md">{{ $t('Charger') }}</div>
      </div>
      <div class="charger-info u-grey-text t-h2--md pl-1 d-block d-sm-none">{{ $t('Included') }}</div>
      <div class="charger-info u-grey-text t-h2--md pl-1 text-lowercase d-none d-sm-block">{{ $t('Included') }}</div>
    </div> -->

    <!-- <div class="c-product-resume__content d-flex align-items-center justify-content-sm-start justify-content-between mt-sm-1 mt-3 mb-1">
      <div class="d-flex align-items-center">
        <div class="icon__no-charger mr-2"></div>
        <div class="charger-info u-grey-text t-h2--md">{{ $t('Charger') }}</div>
      </div>
      <div class="charger-info u-grey-text t-h2--md pl-1 d-block d-sm-none">{{ $t('Not included') }}</div>
      <div class="charger-info u-grey-text t-h2--md pl-1 text-lowercase d-none d-sm-block">{{ $t('Not included') }}</div>
    </div> -->

    <div class="u-marg-t-sm u-marg-b-sm--sm">
      <a
        href="#"
        :tabindex="addToCartButtonState.tabindex"
        role="button"
        :aria-disabled="addToCartButtonState.disabled"
        :class="[
          'btn btn-lg btn-primary u-block--xs u-full-width--xs u-center--xs gtm-section-regular-add-to-cart',
          addToCartButtonState.disabled ? 'u-cursor-pointer-not-allowed' : '',
          !addToCartButtonState.discret && addToCartButtonState.disabled ? 'disabled' : '',
          packageWithPhone ? 'js-modal-add' : ''
        ]"
        :data-toggle="!packageWithPhone && currentProduct.device_plan_sku && currentProduct.device_plan_sku.length > 0 ? '' : ''"
        :data-target="!packageWithPhone && currentProduct.device_plan_sku && currentProduct.device_plan_sku.length > 0 ? '' : ''"
        @click="addToCart"
      >
        <span>{{ $t('Add to cart') }}</span>
        <img
          v-show="addToCartButtonState.loading"
          :src="productInformations.loaderUrl"
          class="u-marg-l-xxs"
          style="max-width: 16px"
          alt=""
        />
      </a>
    </div>
  </div>
</template>

<script>
import MixinAddToCart from './Mixins/MixinAddToCart'
import {CalculateMobilePrice, FormatPrice} from './Mixins/CustomOptionsMixins'

export default {
  mixins: [MixinAddToCart],
  computed: {
    priceFormattedForPromo () {
        let monthly_price = this.currentProduct.plan.monthly_price ? parseFloat(this.currentProduct.plan.monthly_price) : 0
        let instalment_amount = this.currentProduct.plan.instalment_amount ? parseFloat(this.currentProduct.plan.instalment_amount) : 0

        let price = instalment_amount ? monthly_price + instalment_amount : monthly_price

        if (price === '') price = 0

        if (price % 1 !== 0) {
            price = price.toFixed(2)
        }

        if (this.productInformations.locale === 'en') {
            return `${this.currentProduct.currency}${price}`
        } else {
            return `${FormatPrice(price.toString(), 'fr')}${this.currentProduct.currency}`
        }
      },
    hasInstalmentFee () {
      if (this.currentProduct.instalment && this.currentProduct.instalment.final_price) {
        if (parseFloat(this.currentProduct.instalment.final_price) === 0) {
          return true
        } else if (parseFloat(this.currentProduct.instalment.final_price) > 0){
          return false
        }
      } else {
        return false
      }
    },
    mobilePrice () {
      let optionPrice = parseFloat(this.currentProduct.plan.price) + parseFloat(this.productInformations.prices[this.currentProduct.sku].price);
      return CalculateMobilePrice({optionPrice: optionPrice, currency: this.currentProduct.currency, locale: this.productInformations.locale})
    },
     dateTimeForPlansPromo() {
          let startDate
          let endDate
          if (this.currentProduct.plan.promo_date_start_1 || this.currentProduct.plan.promo_date_end_1) {
              startDate = this.currentProduct.plan.promo_date_start_1;
              endDate = this.currentProduct.plan.promo_date_end_1;
          } else {
              return false;
          }

          let timezone = this.currentProduct.plan.timezone_config;
          var now = new Date();
          var currentTime = now.toLocaleString('sv-SE', {timeZone: timezone});

          return startDate <= currentTime && endDate >= currentTime
      },
    textForDiscountPromo () {
        let promo_price_text = this.currentProduct.plan.plan_promo_subscription_duration
        const instalmentMonthlyRegularPrice = parseFloat(this.currentProduct.instalment.instalment_amount) ?? 0
        const planMonthlyRegularPrice = parseFloat(this.currentProduct.plan.monthly_price) ?? 0
        const liveboxDiscountPrice = parseFloat(this.currentProduct.plan.subscription_convergent_discount) ?? 0
        let monthlyRegularPrice = instalmentMonthlyRegularPrice + planMonthlyRegularPrice

        monthlyRegularPrice = this.showLiveboxAdvantage() ? (monthlyRegularPrice - liveboxDiscountPrice) : monthlyRegularPrice;

        let text_with_discount_for_promo
        if (promo_price_text !== '1') {
            text_with_discount_for_promo = `${this.$t('for %1 months, then <br/>%2/month').replace('%1', promo_price_text).replace('%2', this.formatPrice(monthlyRegularPrice))}`
        } else {
            text_with_discount_for_promo = `${this.$t('for %1 month, then <br/>%2/month').replace('%1', promo_price_text).replace('%2', this.formatPrice(monthlyRegularPrice))}`
        }

        return text_with_discount_for_promo
    }
  },
    methods: {
        formatPrice(price) {
            if (isNaN(parseInt(price))) {
                return price
            }

            price = parseFloat(price);

            if (price % 1 === 0) {
                price = parseInt(price, 10);
            } else {
                price = price.toFixed(2);
            }

            const formattedPrice = this.productInformations.locale === 'en'
                ? price
                : price.toString().replace('.', ',');

            return this.productInformations.locale === 'en'
                ? `€${formattedPrice}`
                : `${formattedPrice}€`;
        },
        showLiveboxAdvantage() {
            if (!this.currentProduct.plan.subscription_convergent_discount || this.currentProduct.plan.subscription_convergent_discount.length === 0) {
                return false;
            }

            let queryParam = new URLSearchParams(window.location.search);
            if (+queryParam.get('livebox_prices')) {
                return true;
            } else if (queryParam.get('livebox_prices') == 0) {
                return false;
            }

            return localStorage.getItem('is_enable_livebox_for_plan') === '1';
        },
    }
}
</script>
